<template>
  <at-alert :title="$t('shared.ui.otpInfoBlock.title')">
    <ul class="flex flex-col gap-1 list-disc text-gray-500 dark:text-gray-300">
      <li>
        {{ $t('shared.ui.otpInfoBlock.steps[0]') }}
      </li>

      <li>
        {{ $t('shared.ui.otpInfoBlock.steps[1]') }}
      </li>

      <li>
        {{ $t('shared.ui.otpInfoBlock.steps[2]') }}
      </li>

      <li>
        {{ $t('shared.ui.otpInfoBlock.steps[3]') }}
      </li>

      <li>
        <p class="pt-0.5 flex-grow text-sm">
          <i18n-t keypath="shared.ui.otpInfoBlock.steps[4]">
            <template #technicalSupport>
              <a class="underline" href="https://t.me/alifpartnerschat" target="_blank">
                {{ $t('shared.ui.otpInfoBlock.technicalSupport') }}
              </a>
            </template>
          </i18n-t>
        </p>
      </li>
    </ul>
  </at-alert>
</template>

<script setup>
  import { AtAlert } from '@packages/aliftech-ui';
</script>
